module.exports = __webpack_public_path__ + "static/media/logo-zh-f.9bf6f504.svg";